import React, { useEffect } from 'react';
import profilebg from '../assets/profileo.png'
import  { useState } from 'react';
import { user_profile, update_user } from '../../../api/api.js';

function Profilebox(){


    const [firstName, setfirstName] = useState('');
    const [lastName, setlastName] = useState('');
    const [occupation, setOccupation] = useState('');
    const [departmentname, setDepartment] = useState('');
    const [contactNo, setContactno] = useState('');
    const [emailid, setEmail] = useState('');
    const [id, setId] = useState('');
 

    const getUser = async () => {
      const response = await user_profile();

      if (response.status === 200 && response.data.userData) {
        const user = response.data.userData;
       // console.log('Response in Profile ',response.data.userData);
    
        // Assuming setTbid, setfirstName, setlastName, setContactno are defined
       
        setfirstName(user.givenname);
        setlastName(user.lastname);
        setDepartment(user.dept_name);
        setEmail(user.ndsu_emailid);
        setContactno(user.contactnumber);
        setOccupation(user.occupation);
    
      }
    };


    const handleUpdate = async (e) => {
      e.preventDefault();
      try {
          const response = await update_user(firstName, lastName, departmentname, occupation, Number(contactNo), emailid);
          console.log("API Response:", response); // Log response for debugging
  
          if (response && response.status === 200) {
              alert('User updated successfully');
          } else {
              console.log(`Update failed:`, response); // Log the entire response for debugging
              alert(`Update failed: ${response?.message || 'Unknown error'}`);
          }
      } catch (error) {
          console.error("Failed to update user data", error);
          alert('An unexpected error occurred.');
      }
  };
    

    useEffect (() => {
      getUser();
    },[])


    
 

    return (

        <div className='profileback'> <div className="profileform ">

            <div className='headbox w-10/12'> <h3>Edit Your Profile</h3>
            </div>

<div className="w-full ml-10 mt-10">
      <form className="w-10/12 bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" >

     

        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="firstName">
            First Name
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-500 focus:shadow-outline focus:border-purple-500"
            id="firstName"
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setfirstName(e.target.value)}
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="lastName">
            Last Name
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-500 focus:shadow-outline focus:border-purple-500"
            id="lastName"
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setlastName(e.target.value)}
          />
        </div>

        <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="emailid">
            Email
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2  focus:shadow-outline focus:border-lime-950"
            id="emailid"
            type="email"
            placeholder="Email"
            value={emailid} disabled
            onChange={(e) => setEmail(e.target.value)}
            style={{ color: 'DarkGrey' }}
          />
          </div>

          
        <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="departmentname">
          Department
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 leading-tight"
          id="departmentname"
          type="text"
          placeholder="Department"
          value={departmentname} disabled
          onChange={(e) => setDepartment(e.target.value)}
          style={{ color: 'DarkGrey' }}
        />
        </div> 

       


          <div className="mb-4">
<label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="occupation">
  Occupation
</label>
<input
  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-red-500 focus:shadow-outline focus:border-purple-500"
  id="occupation"
  type="text"
  placeholder="Occupation"
  value={occupation}
  onChange={(e) => setOccupation(e.target.value)}
/>
</div>

<div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="contactNo">
            Contact No
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:ring-2 focus:ring-blue-500 focus:shadow-outline focus:border-purple-500"
            id="contactNo"
            type="number"
            placeholder="Contact No"
            value={contactNo}
            onChange={(e) => setContactno(e.target.value)}
          />

          </div>







 

        <div className="flex items-center justify-between">
        <button className="buttonstyle mt-6" type="submit" onClick={handleUpdate} ><span class="text">Submit</span></button>
        
        </div>
      </form>

    </div>

            



       
    </div>
            
             <div className='background'>
                <img src={profilebg} alt="" /> </div>
                
                
                </div>
    )
}

export default Profilebox;




